export const DEFAULT_DURATION = 0.9;

export const DEFAULT_EASE = "power3.out";